import axios from 'axios';
import { DownloadReportDto } from '../../types/report';

export const reportApi = {
	async fetchReportTypes() {
		const { data } = await axios.get(`/report/report-types`, {});
		return data;
	},

	async downloadReport(downloadReportDto: DownloadReportDto) {
		const { data } = await axios.post(
			`/report/reports/event-reports`,
			downloadReportDto,
		);
		return data;
	},

	async fetchJobsCountBySdg(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(`/report/chart-data/jobs-count-by-sdg`, {
			params: {
				periodStart,
				periodEnd,
				centerIds,
			},
		});
		return data.data;
	},

	async fetchEventCountByActivityTheme(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/events-count-by-activity-theme`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},

	async fetchEventAttendancesByMonth(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/event-attendances-by-month`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},

	async fetchJobHoursByMonth(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(`/report/chart-data/job-hours-by-month`, {
			params: {
				periodStart,
				periodEnd,
				centerIds,
			},
		});
		return data.data;
	},

	async fetchJobsMostEngaged(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(`/report/chart-data/jobs-most-engaged`, {
			params: {
				periodStart,
				periodEnd,
				centerIds,
			},
		});
		return data.data;
	},

	async fetchJobTopVolunteers(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(`/report/chart-data/job-top-volunteers`, {
			params: {
				periodStart,
				periodEnd,
				centerIds,
			},
		});
		return data.data;
	},

	async fetchEventCheckinMostEngaged(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/events-checkin-most-engaged`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},

	async fetchEventCheckinTopVolunteers(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/event-checkin-top-participants`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},

	async fetchEventTicketMostEngaged(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/events-ticket-most-engaged`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},

	async fetchEventTicketTopVolunteers(
		periodStart: string,
		periodEnd: string,
		centerIds: number[],
	) {
		const { data } = await axios.get(
			`/report/chart-data/event-ticket-top-participants`,
			{
				params: {
					periodStart,
					periodEnd,
					centerIds,
				},
			},
		);
		return data.data;
	},
};
